export default "__VITE_ASSET__f4327ad5__"